import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo1_Maria } from '../../../../../utils/ES/Modals/directors';

const ModalVideoMaria1 = () => {
  return (
    <>
      <ModalVideo
        id="maria-video-1"
        dataText={TextVideo1_Maria}
        videoSrc="https://player.vimeo.com/video/599009298?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_MARIA_1"
      />
    </>
  );
};

export default ModalVideoMaria1;
